import React, { useState } from 'react'

import {
    Paper,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Typography,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
} from '@material-ui/core'
import InfoIcon from '@material-ui/icons/Info'

import { InternalInvoiceEmailLog } from '../../../models/Invoice/types'
import { toMMDDYYYY } from '../../../helpers'

interface Props {
    messages: InternalInvoiceEmailLog[]
}
export const FollowUpHistoryTable: React.FC<Props> = ({ messages }) => {
    const [
        selectedMessage,
        setSelectedMessage,
    ] = useState<InternalInvoiceEmailLog | null>(null)
    const [dialogOpen, setDialogOpen] = useState(false)

    const handleInfoClick = (message: InternalInvoiceEmailLog) => {
        setSelectedMessage(message)
        setDialogOpen(true)
    }

    const handleCloseDialog = () => {
        setDialogOpen(false)
        setSelectedMessage(null)
    }

    if (!messages || messages.length === 0) {
        return (
            <Typography variant="body1">No follow up messages found</Typography>
        )
    }

    return (
        <>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Sent Date</TableCell>
                            <TableCell>Sent To</TableCell>
                            <TableCell>Subject</TableCell>
                            <TableCell>Details</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {messages.map((message) => (
                            <TableRow key={message.id}>
                                <TableCell>
                                    {toMMDDYYYY(new Date(message.created_date))}
                                </TableCell>
                                <TableCell>{message.recipient}</TableCell>
                                <TableCell>{message.subject}</TableCell>
                                <TableCell>
                                    <IconButton
                                        size="small"
                                        onClick={() => handleInfoClick(message)}
                                        title="View email content"
                                    >
                                        <InfoIcon />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            <Dialog
                open={dialogOpen}
                onClose={handleCloseDialog}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle>Email Details</DialogTitle>
                <DialogContent>
                    {selectedMessage && (
                        <div>
                            <Typography variant="h6" gutterBottom>
                                Subject: {selectedMessage.subject}
                            </Typography>
                            <Typography
                                variant="body2"
                                color="textSecondary"
                                gutterBottom
                            >
                                To: {selectedMessage.recipient}
                            </Typography>
                            <Typography
                                variant="body2"
                                color="textSecondary"
                                gutterBottom
                            >
                                Sent:{' '}
                                {toMMDDYYYY(
                                    new Date(selectedMessage.created_date),
                                )}
                            </Typography>
                            <div
                                style={{
                                    marginTop: 16,
                                    padding: 16,
                                    border: '1px solid #e0e0e0',
                                    borderRadius: 4,
                                    backgroundColor: '#fafafa',
                                }}
                                dangerouslySetInnerHTML={{
                                    __html: selectedMessage.content,
                                }}
                            />
                        </div>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
